import { CountryName, flagNameToAlpha2CodeMap } from '~constants/flag';

export const getAlpha2Code = (countryName: CountryName) => {
  if (!flagNameToAlpha2CodeMap[countryName]) {
    return null;
  }

  return flagNameToAlpha2CodeMap[countryName];
};
